import styled from 'styled-components'

import { FlexCol } from 'styles/styled'
import { colors, screenSizes } from 'styles/theme'

export const PrivacyCont = styled.div``

export const Heading = styled.h3`
  font-family: var(--font-tomorrow);
  font-size: 32px;
  font-weight: 600;
  text-transform: uppercase;

  @media (min-width: ${screenSizes.XS}px) {
    font-size: 36px;
  }
`

export const SubHeading = styled(Heading)`
  font-size: 16px;

  @media (min-width: ${screenSizes.XS}px) {
    font-size: 20px;
  }
`

export const SubHeadingUnderline = styled(SubHeading)`
  text-transform: none;
  text-decoration: underline;
  font-weight: 500;

  font-size: 14px;

  @media (min-width: ${screenSizes.XS}px) {
    font-size: 18px;
  }
`

export const Info = styled.p`
  font-family: var(--font-dm-mono);
  font-size: 14px;
  line-height: 24px;
  color: rgba(255, 255, 255, 0.7);

  span {
    color: ${colors.white};
    font-weight: 500;
  }

  @media (min-width: ${screenSizes.XS}px) {
    font-size: 16px;
  }
`

export const ListContainer = styled(FlexCol)<{ isCenter?: boolean }>`
  list-style-position: inside;
  gap: 16px;

  ul {
    display: flex;
    flex-direction: column;

    gap: 16px;
  }

  p {
    display: inline;
  }

  li {
    & > * {
      position: relative;
      left: 10px;
    }

    ul {
      margin-top: 16px;
    }

    &.last-point {
      &:last-child {
        list-style-type: none;
      }
    }
  }

  @media (min-width: ${screenSizes.M}px) {
    padding-left: ${(props) => (props.isCenter ? '100px' : '0')};
    list-style-position: outside;

    li {
      margin-left: 20px;

      & > * {
        position: relative;
        left: 26px;
      }
    }
  }

  &.alphabets {
    ul {
      list-style-type: lower-alpha;
    }
  }
`
